module.exports = __webpack_public_path__ + "static/img/check-verde.89eeb5a0.svg";